import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-male",
  "use": "icon-icon-male-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-male\">\n<path d=\"M8.81751 6.17212C7.32631 6.17212 6.1123 7.38558 6.1123 8.87618C6.1123 10.3679 7.32631 11.5814 8.81751 11.5814C10.3093 11.5814 11.5221 10.3679 11.5221 8.87618C11.5221 7.38438 10.3093 6.17212 8.81751 6.17212Z\" fill=\"#90AFDF\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.62264 0H12.3774C14.378 0 16 1.62143 16 3.62264V12.3774C16 14.3774 14.378 16 12.3774 16H3.62264C1.62204 16 0 14.3774 0 12.3774V3.62264C0 1.62143 1.62204 0 3.62264 0ZM4.83228 8.87613C4.83228 11.0742 6.6206 12.8608 8.81876 12.8608C11.0151 12.8608 12.8034 11.0742 12.8034 8.87613C12.8034 6.67797 11.015 4.88905 8.8187 4.88905C7.95959 4.88905 7.16539 5.16504 6.51325 5.62964L5.3016 4.41738H6.93312V3.13672H3.19727V6.85844H4.47733V5.40558L5.60173 6.53059C5.11944 7.18858 4.83228 7.99758 4.83228 8.87613Z\" fill=\"#90AFDF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-male.svg
// module id = 5MGl
// module chunks = 111